import React, { useRef } from 'react'
import { getImage } from 'gatsby-plugin-image'
import Loadable from '@loadable/component'
// TinySlider is client-side only
import TinySlider from 'tiny-slider-react'

const HomepageHeroSlider = Loadable(() => import('./HomepageHeroSliderInner'))

export default HomepageHeroSlider
